export default __webpack_public_path__ + "static/media/icon-logo.c9dfa0d2.svg";